import { Body, Heading, Icon } from '@assembly-js/design-system';

export const InternalChatError = (props: { error: string }) => {
  return (
    <div className="w-full h-full flex flex-col items-center mt-12 gap-3">
      <Icon icon="Warning" className="w-8 h-8 text-warning-primary" />
      <Heading size="xl" className="text-black-heading">
        {props.error}
      </Heading>
      <Body size="lg" className="ml-2">
        We couldn’t show this chat. It may have been moved or deleted.
      </Body>
    </div>
  );
};
